import React from 'react';

import cx from './index.module.scss';

interface Props {
  content: React.ReactNode;
}

const CustomMarquee: React.FC<Props> = ({ content }) => {
  return (
    <div className={cx('CustomMarquee')}>
      <div className={cx('content', 'content-1')}>
        <div className={cx('slider-text')}>{content}</div>
        <div className={cx('slider-text')}>{content}</div>
      </div>
    </div>
  );
};

export default CustomMarquee;
